"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var NestedIcon = function (_a) {
    var active = _a.active;
    var fill = active ? '#FE505D' : '#D0D6DA';
    return (react_1.default.createElement("svg", { viewBox: "0 0 50 50", focusable: "false", "data-icon": "up-circle", width: "1em", height: "1em", fill: "currentColor", "aria-hidden": "true" },
        react_1.default.createElement("circle", { cx: "5", cy: "5", r: "4", fill: fill }),
        react_1.default.createElement("circle", { cx: "5", cy: "20", r: "4", fill: fill }),
        react_1.default.createElement("circle", { cx: "5", cy: "35", r: "4", fill: fill }),
        react_1.default.createElement("circle", { cx: "20", cy: "35", r: "4", fill: fill })));
};
NestedIcon.defaultProps = {
    active: false,
};
exports.default = NestedIcon;
